import React from 'react';
import { useTheme } from '@mui/material/styles';
import Grid from '@mui/material/Grid2';
import { Box, Link, ListItem, ListItemAvatar, ListItemText, Typography} from '@mui/material';
import BarChartIcon from '@mui/icons-material/BarChart';
import GavelIcon from '@mui/icons-material/Gavel';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import AnnouncementIcon from '@mui/icons-material/Announcement';

const services = [
    {
      title: 'Contribution Limits Chart',
      subtitle:
        'Find the limits placed on contributions to a candidate or political committee',
      icon: (
        <BarChartIcon fontSize="large" />
      ),
      link: '/Legal/ContributionLimits'
    },
    {
      title: 'Campaign Finance Law',
      subtitle:
        'The Massachusetts Campaign Finance Law, M.G.L. Chapter 55',
      icon: (
        <GavelIcon fontSize="large" />
      ),
      link: '/Legal/CampaignFinanceLaw'
    },
    {
      title: 'OCPF Regulations',
      subtitle:
        'The Code of Massachusetts Regulations: 970 CMR',
      icon: (
        <MenuBookIcon fontSize="large" />
      ),
      link: '/Legal/Regulations'
    },
    {
      title: 'Agency Actions',
      subtitle:
        'The latest Public Resolution Letters, Disposition Agreements and Attorney General Referrals issued by OCPF',
      icon: (
        <AnnouncementIcon fontSize="large" />
      ),
      link: '/Legal/AgencyActions'
    },
  ];

const FeaturedLegalServices = (): JSX.Element => {

    const theme = useTheme();

    return (
    <Box marginTop={3} marginBottom={4}>
        <Box marginBottom={4}>
        <Typography
          variant="h6"
          sx={{
            textTransform: 'uppercase',
          }}
          fontWeight={700}
          data-aos={'fade-up'}
          gutterBottom
          color={'secondary'}
          align={'center'}
        >
          MOST VISITED
        </Typography>
      </Box>
      <Grid container spacing={4}>
        {services.map((item, i) => (
          <Grid key={i} size={{xs:12, md:3}}>
            <ListItem
              component={Link}
              href={item.link}
              disableGutters
              className='is-clickable'
              data-aos={'fade-up'}
              data-aos-delay={i * 100}
              data-aos-offset={100}
              data-aos-duration={600}
              sx={{
                flexDirection: 'column',
                alignItems: 'center',
                padding: 0,
              }}
            >
              <Box
                component={ListItemAvatar}
                marginBottom={1}
                minWidth={'auto !important'}
              >
                <Box color={'primary.ocpfBlue'}>{item.icon}</Box>
              </Box>
              <ListItemText
                primary={item.title}
                secondary={item.subtitle}
                primaryTypographyProps={{
                  variant: 'h6',
                  gutterBottom: true,
                  align: 'center',
                }}
                secondaryTypographyProps={{ align: 'center' }}
                sx={{
                  '& .MuiListItemText-primary': {
                    fontWeight: 700,
                  },
                  margin: 0,
                }}
              />
            </ListItem>
          </Grid>
        ))}
      </Grid>
    </Box>
    )

}

export default FeaturedLegalServices;